import SpottLogo from '../../../../assets/Logo_Spott_2.svg';
import powerIconSwitch from '../../../../assets/switch-button-power-icon.png';
import carIconSwitch from '../../../../assets/switch-button-car-icon.png';
import mapIconSwitch from '../../../../assets/switch-button-map-icon.png';

import plugLogo from '../../../../assets/plug.png';
import chargerStationLogo from '../../../../assets/charger-station-logo.png';

export const PAGE_DEFAULT_CONFIG = {
  title: 'Spott',
  logo: SpottLogo,
  bgColor: '#3CCC10',
  background: '',
};

export const PAGE_OPTIONS_CONFIG: any = [
  {
    id: 'charger-status',
    label: 'Status de Recarga',
    icon: powerIconSwitch,
    service: '/viewer/ViewerConnectorsStatus/',
    serviceHeader: '/viewer/viewerdata/',
    dataColumn: 'connectors',
  },
  {
    id: 'recharge-priority',
    label: 'Prioridade de Recarga',
    icon: carIconSwitch,
    service: '/viewer/VehicleNearestSite/',
    serviceHeader: '/viewer/viewerdata/',
    dataColumn: 'vehicles',
  },
  {
    id: 'fleet-map',
    label: 'Mapa da Frota',
    icon: mapIconSwitch,
    serviceHeader: '/viewer/viewerdata/',
    serviceMap: [
      { id: 'vehicles', service: '/viewer/ViewerFleetVehicles/' },
      { id: 'connectors', service: '/viewer/ViewerFleetSites/' },
    ],
  },
];

export const PAGE_INFO_CONFIGS: any = {
  'charger-status': {
    icon: plugLogo,
    headerTitle: 'Status dos carregadores',
    headerLabelProps: [
      {
        label: 'Total de carregadores',
        prop: 'count',
      },
    ],
  },
  'recharge-priority': {
    icon: chargerStationLogo,
    headerTitle: 'Prioridade de recarga',
    headerLabelProps: [
      {
        label: 'Total de veículos',
        prop: 'count',
        render: (data: any) => (
          <span className='vp-total-number-of-chargers'>
            {data?.vehicles?.length}
          </span>
        ),
      },
    ],
  },
  'fleet-map': {
    icon: chargerStationLogo,
    headerTitle: 'Mapa da frota',
    headerLabelProps: [
      {
        label: 'Total de veículos',
        prop: 'vehiclesCount', //default do sistema
      },
      {
        label: 'Total de locais',
        prop: 'connectorsCount', //default do sistema
      },
    ],
  },
};

export const getConnectorStatusStyle = (connector: any) => {
  const { connectorStatus, cpStatus } = connector;
  const isOffline = cpStatus === 'Offline';

  // PRIORIDADE 1: STATUS OFFLINE (e suas sub-condições)
  if (
    isOffline &&
    (connectorStatus === null || connectorStatus === 'Available')
  ) {
    return {
      text: 'Desconectado',
      bg: '#EBEEED',
      color: '#AAB2AF',
    };
  }

  // PRIORIDADE 2: STATUS GERAIS

  switch (connectorStatus) {
    case 'Charging':
      return {
        text: 'Carregando',
        bg: '#CEDCE9',
        color: '#2688E2',
      };
    case 'Available':
      return {
        text: 'Disponível',
        bg: '#93E22E',
        color: '#196912',
      };
    case 'Preparing':
      return {
        text: 'Preparando',
        bg: '#CEDCE9',
        color: '#2688E2',
      };
    case 'Finishing':
      return {
        text: 'Finalizado',
        bg: '#EF6D44',
        color: '#FFFFFF',
      };
    case 'SuspendedEV':
    case 'SuspendedEVSE':
      return {
        text: 'Pausado',
        bg: '#FEE7E2',
        color: '#B9381C',
      };
    case 'Unavailable':
      return {
        text: 'Indisponível',
        bg: '#FEE7E2',
        color: '#B9381C',
      };
    case 'Faulted':
      return {
        text: 'Falha',
        bg: '#EBEEED',
        color: '#AAB2AF',
      };
    default:
      // Caso de fallback para status desconhecido
      return {
        text: connectorStatus || 'Desconhecido',
        bg: '#CCCCCC',
        color: '#333333',
      };
  }
};
